"use strict";

exports.__esModule = true;
var _PluginButtonBar = require("./PluginButtonBar");
Object.keys(_PluginButtonBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PluginButtonBar[key]) return;
  exports[key] = _PluginButtonBar[key];
});